(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar2"] && !Shopify.designMode) return;
  try {
    
/*
  Announcement Bar — JS enhancement
  Dynamically syncs animation duration to actual content width
  so speed feels consistent at any screen size.
*/
(function () {
  'use strict';

  const initBar = (section) => {
    const track = section.querySelector('.announcement-bar__track');
    if (!track) return;

    const inner = track.querySelector('.announcement-bar__inner');
    if (!inner) return;

    const updateSpeed = () => {
      // Base speed from CSS custom property (seconds per full viewport width)
      const baseDuration = parseFloat(
        getComputedStyle(section).getPropertyValue('--bar-speed') || '30'
      );

      // Width of one full set of messages
      const contentWidth = inner.offsetWidth;
      const vpWidth = window.innerWidth;

      // Scale duration so px/s stays constant regardless of content length
      const pxPerSec = vpWidth / baseDuration;
      const adjustedDuration = contentWidth / pxPerSec;

      track.style.animationDuration = `${adjustedDuration}s`;
    };

    updateSpeed();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSpeed, 150);
    });
  };

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement-bar').forEach(initBar);
  });

  // Shopify Theme Editor live reload
  document.addEventListener('shopify:section:load', (e) => {
    const bar = e.target.querySelector('.announcement-bar');
    if (bar) initBar(bar);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
